import React, { useEffect, useState } from "react";
import { Card, CardBody, Container } from "reactstrap";
import Table from "../../components/Common/Table";
import Loader from "../../components/Common/Loader";
import Pagination from "../../components/Common/Pagination_ansync";
import { getGestionPorContacto } from "../../helpers/backend";
import { useSelector } from "react-redux";
import ModalManagementDetails from "../Whatsapp/components/ModalManagementDetails";

const GestionContactoTablaSolo = ({ contactId }) => {
  const [params, setParams] = useState({
    count: 0,
    next: null,
    previous: null,
    results: [],
  });
  const [loading, setLoading] = useState(false);
  const [detallesModal, setDetallesModal] = useState(false);
  const [GestionDetallada, setGestionDetallada] = useState(false);

  const theme = useSelector(s => s.theme.theme) || "light";
  useEffect(() => {
    getGestionesData();
    // eslint-disable-next-line
  }, [contactId]);

  const getGestionesData = async () => {
    setLoading(true);
    const response = await getGestionPorContacto(contactId);
    setParams({
      count: response.data.count,
      next: response.data.next,
      previous: response.data.previous,
      results: response.data.results,
    });

    setLoading(false);
  };

  const handleDetallesModal = () => {
    setDetallesModal(false);
  };

  const columns = [
    { key: "indice", label: "#", filterable: false },
    { key: "created_date", label: "Fecha", filterable: false },
    { key: "contacto ", label: "Cliente", filterable: false },
    { key: "conversation", label: "Telefono", filterable: false },
    { key: "agent", label: "Agente", filterable: false },
    { key: "estado", label: "Estado", filterable: false },
    { key: "accion", label: "Acción", filterable: false },
  ];

  const formattedData = params.results.map((item, idx) => ({
    ...item,
    indice: idx + 1,
    agent: item.agent?.[0]?.[0] ?? "N/A",
    accion: (
      <>
        {(item.estado === "FINALIZADO" || item.estado === "VENCIDO") && (
          <span
            className="fas fa-eye fa-lg me-2"
            style={{ cursor: "pointer", color: '#007bff' }}
            onClick={() => {
              setDetallesModal(true);
              setGestionDetallada(item);
            }}
          />
        )}
        {item.estado === "EN_GESTION" && (
          <span
            className="fas fa-pen fa-lg"
            style={{ cursor: "pointer", color: '#28a745' }}
            onClick={() => {
              setDetallesModal(true);
              setGestionDetallada(item);
            }}
          />
        )}
      </>
    ),
  }));
  return (
    <div className="p-1 page-content">
      <Container fluid>
        {detallesModal ? (
          <ModalManagementDetails
            isOpen={detallesModal}
            onCloseClick={handleDetallesModal}
            GestionDetallada={GestionDetallada}
          />
        ) : null}

        <Card>
          <CardBody className="">
            {loading ? (
              <Loader />
            ) : (
              <>
                <div className="table-responsive">
                  <Table data={formattedData} 
                  columns={columns} 
                  theme={theme}                   
                  viewExport={false}
                  viewImport={false}  />
                </div>
                <Pagination
                  count={params.count}
                  next={params.next}
                  previous={params.previous}
                  limit={30}
                  filter={false}
                  contact={contactId}
                  baseUrl={`contact/gestionContacto/get_gestiones_contacto/`}
                  filterFunction={getGestionesData}
                />
              </>
            )}
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default GestionContactoTablaSolo;